export class AppointmentViewModel {
  id: number;
  title: string;
  start?: Date;
  end?: Date;
  url?: string;
  isFullDay?: boolean;
}
